module.exports = __webpack_public_path__ + "static/media/user-shield.4a345f5d.svg";